import React from 'react';
import cn from 'classnames';
import Textarea from '@dealroadshow/uikit/core/components/Textarea';
import Input from '@dealroadshow/uikit/core/components/Input';
import ReCaptcha from '@/Framework/UI/Molecules/Form/ReCaptcha';

import { buttonStyles } from '@dealroadshow/uikit/core/components/Button';
import contactFormStyles from './contactForm.scss';

interface IProps {
  FieldComponent: React.ElementType,
  isInvalid: boolean,
  isPristine: boolean,
}

const ContactFormFields = ({
  FieldComponent,
  isInvalid,
  isPristine,
}: IProps) => {
  return (
    <div className={ contactFormStyles.inputContainer }>
      <FieldComponent
        name="name"
        type="text"
        placeholder="Full Name (Optional)"
        component={ Input }
        dataTest="contactFullNameInput"
      />
      <div className={ contactFormStyles.inputContainer }>
        <FieldComponent
          name="email"
          type="email"
          placeholder="Email (Optional)"
          component={ Input }
          dataTest="contactEmailInput"
        />
      </div>
      <FieldComponent
        name="feedback"
        data-test="feedback"
        textareaClassName={ contactFormStyles.textarea }
        placeholder="Your notes..."
        component={ Textarea }
        dataTest="contactFormFeedbackTextarea"
      />
      <div className={ contactFormStyles.captcha }>
        <FieldComponent
          data-test="recaptcha"
          name="recaptcha"
          component={ ReCaptcha }
        />
      </div>
      <button
        data-test="companyUsContactFormSubmitButton"
        className={ cn(buttonStyles.btn, buttonStyles.action, contactFormStyles.submitBtn) }
        type="submit"
        disabled={ isInvalid || isPristine }
      >
        Submit
      </button>
    </div>
  );
};

export default ContactFormFields;
